module.exports = __webpack_public_path__ + "static/media/hm.669db6c4.svg";